import { createFileRoute, notFound } from '@tanstack/react-router';
import A2UIWorkbenchLayout from '@/a2ui/router/A2UIWorkbenchLayout';
import { loadA2UIRouteData } from '@/serverDataFn';
import type { A2UIGallerySidebarEntry } from '@/a2ui/gallery/a2uiGalleryExamples';
import type { A2UIRouteData } from '@/a2ui/serverData';

export type WorkbenchShellData = { sidebarExamples: A2UIGallerySidebarEntry[]; initialSidebarExpanded: boolean };

function getWorkbenchShellData(data?: A2UIRouteData): WorkbenchShellData | null {
  if (!data || data.kind === 'home' || data.kind === 'redirect' || data.kind === 'not-found') return null;
  return { sidebarExamples: data.sidebarExamples, initialSidebarExpanded: data.initialSidebarExpanded };
}

export const Route = createFileRoute('/_workbench')({
  loader: async () => {
    const routeData = (await loadA2UIRouteData({ data: '/a2ui-gallery' })) as A2UIRouteData;
    const shellData = getWorkbenchShellData(routeData);
    if (!shellData) throw notFound();
    return shellData;
  }, // Use `loader` instead of `beforeLoad` so the result is cached by `defaultStaleTime`. `beforeLoad` would re-fire the server function on every child-route navigation regardless of stale time.
  component: A2UIWorkbenchLayout,
});
